import { hasDoneOnboarding } from '../services/OnboardingService';
import { isIOSSafari } from './browser';
import { isMobileLayout } from './isMobileLayout';

/* eslint-disable @typescript-eslint/no-explicit-any */
let pwaInstallPrompt: any;
let appInstalled = false;
let refusedInstall = getRefusedInstall();

export function registerPwaInstallListener(): void {
    window.addEventListener('beforeinstallprompt', (event: Event) => {
        event.preventDefault();
        pwaInstallPrompt = event as any;
    });

    window.addEventListener('appinstalled', () => {
        appInstalled = true;
    });
}

export async function installPwa(): Promise<boolean> {
    if (!hasPromptAvailable()) {
        return false;
    }

    const result = await pwaInstallPrompt.prompt();
    const isAccept = result.outcome === 'accepted';

    if (!isAccept) {
        setRefusedInstall();
    }

    return isAccept;
}

// Auto-trigger gate: returns true only when we'd like to nag the user with the
// install modal without them asking. Both Android (programmatic prompt) and
// iOS Safari (manual Share → Add to Home Screen instructions) qualify; the
// modal renders the right content based on `getInstallFlow()`.
export function canInstallPwa(): boolean {
    return !appInstalled
        && !refusedInstall
        && !isRunningStandalone()
        && hasInstallFlow()
        && hasDoneOnboarding()
        && isMobileLayout();
}

// Settings entry gate: same as auto-trigger but ignores `refusedInstall`, so
// users who dismissed the auto-prompt can still re-open it deliberately.
export function canShowPwaInstallEntry(): boolean {
    return !appInstalled
        && !isRunningStandalone()
        && hasInstallFlow()
        && isMobileLayout();
}

export type InstallFlow = 'prompt' | 'ios-manual';

export function getInstallFlow(): InstallFlow | null {
    if (hasPromptAvailable()) {
        return 'prompt';
    }

    if (isIOSSafari()) {
        return 'ios-manual';
    }

    return null;
}

function hasInstallFlow(): boolean {
    return getInstallFlow() != null;
}

function isRunningStandalone(): boolean {
    return window.matchMedia('(display-mode: standalone)').matches;
}

function hasPromptAvailable(): boolean {
    return pwaInstallPrompt != null;
}

export function setRefusedInstall() {
    refusedInstall = true;
    localStorage.setItem('refusedPwa', '1');
}

function getRefusedInstall() {
    return localStorage.getItem('refusedPwa') === '1';
}
